export default __webpack_public_path__ + "images/news/claas_arion_400_4.jpg";